import { render } from "./rulesMobile.vue?vue&type=template&id=2a2358d4&scoped=true"
import script from "./rulesMobile.vue?vue&type=script&lang=js"
export * from "./rulesMobile.vue?vue&type=script&lang=js"

import "./rulesMobile.vue?vue&type=style&index=0&id=2a2358d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2358d4"]])

export default __exports__